import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { MouseEventHandler, useContext } from 'react';
import { AVAILABLE_COMBO_STOCK } from '@/constants/common';
import { CartContext } from '@/context/CartProvider';
import { useAppSelector } from '@/hooks/reduxHooks';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import { ComboVariant2 } from '@/models/Combo';
import { selectCurrentVendor } from '@/store/features/locationSlice';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
import { ProductListTypeEnum } from '@/utils/analytics/types';
import AddRemoveButton from '../AddRemoveButton';
import ButtonLabel, { VARIANT } from '../ButtonLabel';
import PlusIcon from '../icons/PlusIcon';
interface Props {
  btnContainerStyle?: string;
  index?: number;
  listType?: ProductListTypeEnum;
  minQty?: number;
  productVariant: ComboVariant2;
  maxQty?: number;
  productId?: number;
  productName?: string;
  productBrand?: string;
  productCategory?: string;
}
const ComboAddToCart = ({
  btnContainerStyle,
  index,
  listType,
  minQty,
  productVariant,
  productName
}: Props) => {
  const {
    t
  } = useTranslation('products');
  const {
    trackCustomEvent
  } = useTriggerEvents();
  const vendorDetails = useAppSelector(selectCurrentVendor);
  const router = useRouter();
  const {
    comboItems,
    updateCart
  } = useContext(CartContext);
  const stopBubbling: MouseEventHandler<HTMLElement> = e => {
    e.preventDefault();
    e.stopPropagation();
  };
  const StockInSS = typeof window !== 'undefined' && sessionStorage?.getItem(AVAILABLE_COMBO_STOCK);
  const availableStock = StockInSS ? JSON.parse(StockInSS) : undefined;
  const quantity = comboItems[productVariant.id] || 0;
  const disableRemove = !(typeof minQty === 'undefined' || quantity > minQty);
  const diasbleAdd = availableStock && availableStock[productVariant.id] !== 'undefined' && quantity >= availableStock[productVariant.id];
  const onAddOrRemoveFromCart = (isAdd: boolean) => {
    updateCart({
      variantId: productVariant.id.toString(),
      quantity: 1,
      index,
      type: listType,
      variantPrice: productVariant.price,
      variantDiscount: productVariant.discount_amount,
      name: productName || '',
      brandName: '',
      catalogueId: 0,
      groupId: {},
      isCombo: true
    }, isAdd);
  };
  return <div data-sentry-component="ComboAddToCart" data-sentry-source-file="ComboAddToCart.tsx">
      {quantity === 0 ? <button className="flex justify-center items-center bg-primary-100 py-2.5 rounded-lg min-w-[110px]" onClick={e => {
      onAddOrRemoveFromCart(true);
      const eventParam = {
        ProductName: productVariant?.name,
        ProductVariant: productVariant.id,
        ProductBrand: '',
        ProductPrice: productVariant.price,
        Page: router.asPath,
        VendorName: vendorDetails?.company_name,
        VendorId: vendorDetails?.id,
        isCombo: true
      };
      if (eventParam.VendorId && eventParam.VendorName) {
        trackCustomEvent(CustomEventTypes.ADD_TO_CART, JSON.stringify(eventParam));
      }
      stopBubbling(e);
    }}>
          <PlusIcon height={20} width={20} className="fill-transparent stroke-white" />
          <ButtonLabel variant={VARIANT.TWO} className="ml-2 font-nato-semibold text-white" label={t('add')} />
        </button> : <AddRemoveButton btnContainerStyle={btnContainerStyle} disableRemove={disableRemove} disableAdd={diasbleAdd} onAdd={() => {
      trackCustomEvent(CustomEventTypes.ADD_ONE_ITEM_TO_CART);
      onAddOrRemoveFromCart(true);
    }} onRemove={() => {
      trackCustomEvent(CustomEventTypes.REMOVE_ONE_ITEM_FROM_CART);
      if (!disableRemove) {
        onAddOrRemoveFromCart(false);
      }
    }} quantity={quantity} />}
    </div>;
};
export default ComboAddToCart;